<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="addressForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="address" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                addressForm: () => import('../forms/AddressForm'),
                address: () => import('../editViews/Address'),
                headers: [
                    { text: 'Street', value: 'street' },
                    { text: 'City', value: 'city' },
                    { text: 'State', value: 'state' },
                    { text: 'Postcode', value: 'postcode' },
                    { text: 'Country', value: 'countryId', table: 'countries', form: () => import('../forms/CountryForm') },
                    { text: 'Coordinates', value: 'coordinates', format: this.formatCoordinates },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    countries: [],
                    items: []
                },
                sorting: [
                    { column: "street", direction: "ascending" },
                    { column: "countryId", direction: "ascending" },
                ],
                itemsField: 'addresses',
                editPageName: 'address',
                apiMethod: 'Addresses',
                claimName: 'Addresses',
                formTitle: 'Address',
                excelTitle: 'Addresses',
                hasEditPage: true,
            }
        },
    };
</script>
